import { render, staticRenderFns } from "./QCCampaignOverview.vue?vue&type=template&id=135ff65e&scoped=true&"
import script from "./QCCampaignOverview.vue?vue&type=script&lang=js&"
export * from "./QCCampaignOverview.vue?vue&type=script&lang=js&"
import style0 from "./QCCampaignOverview.vue?vue&type=style&index=0&id=135ff65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135ff65e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {
  VAutocomplete,
  VList,
  VListTile,
  VListTileTitle,
  VMenu,
  VSelect,
})
